<template>
  <v-card>
    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm8 md8>
            <v-card style="border: 1px solid black" class="pa-3">
              <v-layout row>
                <EditClientAddress @update="updateData($event)" />
              </v-layout>
            </v-card>
            <v-card style="border: 1px solid black" class="pa-3 mt-4">
              <div>
                <h3 class="headline mb-1">Payment Method</h3>
              </div>
              <div>
                <v-radio-group v-model="column">
                  <v-radio
                    v-for="(radio, n) in radios"
                    :key="n"
                    :label="`${radio.name}`"
                    :value="radio.value"
                  ></v-radio>
                </v-radio-group>
              </div>
              <v-layout row>
                <v-flex xs12>
                  <v-btn color="success" block @click="payNow">Pay Now</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-card class="pa-3 ml-4 grey lighten-4" flat>
              <h3 class="headline" align="center">Payment Details</h3>
              <div class="mt-3">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row>
                    <v-flex xs8>
                      <v-subheader>Enter Your Expected Amount</v-subheader>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="editedItem.amount"
                        :rules="[(v) => !!v || 'This field is required!']"
                        type="number"
                        placeholder="Enter Amount"
                        @focus="gatewayCharge()"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs8>
                      <v-subheader>Payment Gateway Charge: {{ gatewayChargeRate }} %</v-subheader>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="editedItem.gateway_charge"
                        type="number"
                        :value="total"
                        disabled
                        label="Total Gateway Charge"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs8>
                      <v-subheader>Total Payable Amount</v-subheader>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="editedItem.total_amount"
                        type="number"
                        :value="total"
                        disabled
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { EditClientAddress } from "@/components/index";
export default {
  components: {
    EditClientAddress,
  },
  data() {
    return {
      valid: true,
      dialog: false,
      clicked: false,
      apiUrl: "client-pay",
      editedItem: {
        amount: null,
        gateway_charge: null,
        total_amount: null,
      },
      // defaultItem: {
      //   amount: null,
      //   gateway_charge: null,
      //   total_amount: null,
      // },
      column: 1,
      radios: [{ name: "Payment Getway", value: 1 }],
      client: {
        address: null,
      },
    };
  },

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    total: function () {
      return this.gatewayCharge(this.val);
    },
    gatewayChargeRate: function () {
      if(this.indexData.gatewayCharges){
        return this.indexData.gatewayCharges.amount
      }
      return 0;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", ["payment.gateway-charge-info"]);
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    gatewayCharge() {
      if (this.indexData.gatewayCharges) {
        this.editedItem.gateway_charge = (
          this.editedItem.amount *
          (this.indexData.gatewayCharges.amount / 100)
        ).toFixed(2);
        this.editedItem.total_amount = (parseFloat(this.editedItem.gateway_charge) + parseFloat(this.editedItem.amount)).toFixed(2);
      } else {
        this.editedItem.gateway_charge = 0;
        this.editedItem.total_amount = 0;
      }
    },
    updateData(event) {
      this.client.address = event;
      // console.log(event);
    },

    payNow() {
      if (this.client.address == null) {
        alert("Your billing address should not be null");
      } else {
        if (this.$refs.form.validate()) {
          var popUpMsg = confirm("Are you sure you want to pay?");
          if (popUpMsg) {
            // console.log(this.editedItem);
            this.$store.dispatch("storePayment", [
              "add-money",
              this.editedItem,
            ]);
            this.close();
          }
        }
      }
    },
  },
};
</script>

<style>
.flex_border {
  border-color: black !important;
}
</style>
